import React from 'react';
import styled, { css } from 'styled-components';

import Check from '@/components/atom/icon/f2f/Check';
import FloatingBottomSheet from '@/components/templates/f2f/common/floating-bottom-sheet';
import { FreeInfluenzaFilter } from '@/parsers/f2f/common';

interface Props {
  freeInfluenzaFilters: FreeInfluenzaFilter[];
  selectedFreeInfluenzaFilter: FreeInfluenzaFilter;
  closeBottomSheet: () => void;
  onClickFilter: (selectedFreeInfluenzaType: FreeInfluenzaFilter) => void;
}
const FreeInfluenzaBottomSheet = ({
  freeInfluenzaFilters,
  selectedFreeInfluenzaFilter,
  onClickFilter,
  closeBottomSheet,
}: Props) => {
  return (
    <FloatingBottomSheet index={700} isOpened={true} onClickOverlay={closeBottomSheet}>
      <Wrapper>
        <Title>무료 접종만 보시겠어요?</Title>
        <InfluenzaFreeList>
          {freeInfluenzaFilters.map((freeInfluenzaFilter) => (
            <FreeInfluenzaItem
              key={`freeInfluenza-${freeInfluenzaFilter.getTitle()}`}
              onClick={() => onClickFilter(freeInfluenzaFilter)}
            >
              <span>{freeInfluenzaFilter.getTitle()}</span>
              {freeInfluenzaFilter.isSelected(selectedFreeInfluenzaFilter.type) && <Check />}
            </FreeInfluenzaItem>
          ))}
        </InfluenzaFreeList>
      </Wrapper>
    </FloatingBottomSheet>
  );
};

export default FreeInfluenzaBottomSheet;

export const Wrapper = styled.div`
  width: 328px;
  padding: 12px 0 16px;
`;

const Title = styled.h4`
  ${({ theme }) => css`
    ${theme.typography.UI20SB}
    color: ${theme.color.gray800};
    margin-bottom: 8px;
    padding: 0 24px;
  `}
`;

const InfluenzaFreeList = styled.ul`
  display: flex;
  flex-direction: column;
`;

const FreeInfluenzaItem = styled.li`
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  ${({ theme }) => css`
    & > span {
      ${theme.typography.UI16M}
      color: ${theme.color.gray700};
    }
  `}
`;
